import APIClient from '../services/APIClient';
import { appendInlineParams } from './helper';

export class Plaza {
  structureUpdate = (inlineParams = {}, bodyParams = {}) => APIClient.put(appendInlineParams('/plazas/:plazaId', inlineParams), bodyParams);

  getLockStatus = (inlineParams) => APIClient.get(appendInlineParams('/plazas/:plazaId/editing/lock', inlineParams));

  editingLock = (inlineParams) => APIClient.put(appendInlineParams('/plazas/:plazaId/editing/lock', inlineParams));

  editingUnlock = (inlineParams) => APIClient.delete(appendInlineParams('/plazas/:plazaId/editing/lock', inlineParams));

  getUpdatedStatus = (inlineParams, config) => APIClient.get(appendInlineParams('/plazas/:plazaId/editing/details', inlineParams), config);
}

export default new Plaza();
